module.exports = __webpack_public_path__ + "static/media/billing.790fde5e.svg";